import { render, staticRenderFns } from "./businessLetters-add.vue?vue&type=template&id=43b69506&"
import script from "./businessLetters-add.vue?vue&type=script&lang=js&"
export * from "./businessLetters-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports